import {type Stats, type CounterEffect, type SetStatProps, type StatID, type SetEquippedStatsProps, type Items, type Inventory } from 'src/types'

const setPlayerStat = (dispatch: (arg0: SetStatProps) => void, statID: StatID, statEffect: CounterEffect) => {
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID,
    statEffect
  })
  
  dispatch({
    type: 'UPDATE_TOTAL_STATS'
  })
}

const rest = (dispatch: (arg0: SetStatProps) => void, stats: Stats) => {
  // STR
  const strLevels = Math.floor(stats.player.player_str_exp / 100)
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_str',
    statEffect: {
      '+': strLevels
    }
  })

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_hp_max',
    statEffect: {
      '+': strLevels
    }
  })

  const remainingStrXP = stats.player.player_str_exp - 100 * strLevels

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_str_exp',
    statEffect: {
      '=': remainingStrXP
    }
  })

  // DEX
  const dexLevels = Math.floor(stats.player.player_dex_exp / 100)
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_dex',
    statEffect: {
      '+': dexLevels
    }
  })

  const remainingDexXP = stats.player.player_dex_exp - 100 * dexLevels
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_dex_exp',
    statEffect: {
      '=': remainingDexXP
    }
  })

  // VIT
  const vitLevels = Math.floor(stats.player.player_vit_exp / 100)
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_vit',
    statEffect: {
      '+': vitLevels
    }
  })

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_hp_max',
    statEffect: {
      '+': vitLevels * 3
    }
  })

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_ap_max',
    statEffect: {
      '+': vitLevels
    }
  })

  const remainingVitXP = stats.player.player_vit_exp - 100 * vitLevels

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_vit_exp',
    statEffect: {
      '=': remainingVitXP
    }
  })

  // full heal
  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_hp',
    statEffect: {
      '=': 'player_hp_max'
    }
  })

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_ap',
    statEffect: {
      '=': 'player_ap_max'
    }
  })

  dispatch({
    type: 'UPDATE_TOTAL_STATS'
  })
}

const levelUp = (dispatch: (arg0: SetStatProps) => void, stats: Stats) => {
  const levels = Math.floor((stats.player.player_str + stats.player.player_dex + stats.player.player_vit) / 3)

  dispatch({
    type: 'SET_PLAYER_STAT',
    statID: 'player_lvl',
    statEffect: {
      '=': levels
    }
  })

  dispatch({
    type: 'UPDATE_TOTAL_STATS'
  })
}

const resetPlayerStats = (dispatch: (arg0: { type: string}) => void) => {
  dispatch({
    type: 'RESET_STATS'
  })
}

const setEquippedStats = (dispatch: (arg0: SetEquippedStatsProps) => void, items: Items, inventory: Inventory) => {
  dispatch({
    type: 'SET_EQUIPMENT_STATS',
    items,
    inventory
  })

  dispatch({
    type: 'UPDATE_TOTAL_STATS'
  })
}

export {
  setPlayerStat,
  setEquippedStats,
  rest,
  levelUp,
  resetPlayerStats
}
